var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{ref:"form",attrs:{"options":_vm.options,"labelWidth":"100px","disabled":_vm.disabled},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }